import { connect } from "react-redux";

import * as actions from "./actions";

function mapStateToProps(state) {
  return { orders: state.borrowerOrders };
}

function mapDispatchToProps(dispatch) {
  return {
    approveWithdrawalOrder: (orderId) => {
      dispatch(actions.approve_withdrawal_order(orderId));
    },

    approveWithdrawalOrders: (list) => {
      dispatch(actions.approve_withdrawal_orders(list));
    },

    fetchWithdrawalOrders: () => {
      dispatch(actions.get_borrower_withdrawal_orders());
    },

    fetchWithdrawalOrdersByAccount: (accountId) => {
      dispatch(actions.get_borrower_withdrawal_orders_by_account(accountId));
    },

    swapDeposits: () => {
      dispatch(actions.swap_data());
    },
  };
}

export const borrowerOrdersConnector = connect(
  mapStateToProps,
  mapDispatchToProps,
);
